<template>
  <div>
    <div class="title" @click="$emit('click')">
      <div>{{ opinion }}</div>
      <img src="@/assets/next.svg" :class="selectImg(display)" />
    </div>
    <div :class="getClass()">
      <h4 class="h4">{{ eye }}</h4>
      <VvRadioColor :label="response.eye.label" name="color" :color="response.eye.value" />

      <div v-if="response.nose.length !== 0">
        <h4 class="h4">{{ nose }}</h4>
        <div>
          <div class="radioBubble">
            <VvRadioBubble
              v-for="(item, index) in response.nose"
              name="radios"
              :key="item.value"
              :value="index"
              :label="item"
              :disabled="true"
            />
          </div>
        </div>
      </div>
      <div v-if="response.mouth.length !== 0">
        <h4 class="h4">{{ mouth }}</h4>
        <div>
          <div class="scale-question-container">
            <div class="scale-wrapper" v-for="(scale, index) in scales" :key="index">
              <div class="scale-title">{{ $t(scale) }}</div>
              <div class="vv-scale-container">
                <span class="value">{{ response.mouth[index] }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VvRadioColor } from '@/components/common'
import { VvRadioBubble } from '@/components/common'

export default {
  name: 'TastingOpinion',
  components: { VvRadioColor, VvRadioBubble },

  props: {
    response: {
      type: Object,
      require: true
    },
    display: {
      type: Boolean,
      require: true
    }
  },
  data() {
    return {
      eye: '',
      nose: '',
      mouth: '',
      opinion: '',
      scalesByType: [
        'tasting.scale.tanins.title',
        'tasting.scale.corps.title',
        'tasting.scale.alcool.title',
        'tasting.scale.acidite.title',
        'tasting.scale.aromes.title',
        'tasting.scale.sucrosite.title'
      ]
    }
  },
  async mounted() {
    this.eye = this.$t('tasting.eye')
    this.nose = this.$t('tasting.nose')
    this.mouth = this.$t('tasting.mouth')
    this.opinion = this.$t('tasting.opinion')
  },
  computed: {
    scales() {
      return this.scalesByType
    }
  },
  methods: {
    getClass() {
      return this.display ? 'body' : 'bodyNone'
    },
    selectImg(display) {
      return display ? 'img-active' : 'img'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.radioBubble {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.body {
  display: flex;
  flex-direction: column;
  font-size: 18px;
}
.bodyNone {
  display: none;
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 13px;
  align-items: center;
  background-color: $primary;
  padding: 12px;
  font-size: 20px;
  font-weight: 700;
  color: $font-banner;
  cursor: pointer;
  .img {
    height: 30px;
    width: 30px;
  }
  .img-active {
    height: 30px;
    width: 30px;
    transform: rotate(90deg);
  }
}
.scale-question-container {
  text-align: left;
  padding: 0 15px;
  color: black;

  .scale-wrapper {
    margin-bottom: 15px;
  }

  .scale-title {
    font-weight: bold;
    margin-bottom: 5px;
  }

  .scale-label {
    margin-bottom: 4px;
    font-size: 14px;
  }
}
.vv-scale-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;

  .value {
    width: 100px;
    text-align: center;
    border-radius: 8px;
    box-shadow: 1px 2px 10px 0 rgba(183, 183, 183, 0.5);
    background-color: #ffffff;
    padding: 6px 10px;
    border: 2px solid transparent;
    transition: 200ms;
  }
}

.h4 {
  width: 95%;
  color: #ffffff;
  background-color: rgb(105, 103, 103);
  padding: 5px 5px;
  margin: 10px auto;
  text-align: center;
  border-radius: 10px;
}
.vv-bubble {
  min-height: 50px;
}
</style>
